.issueTn {
  display: flex;
  justify-content: center;
  position: relative;
}

.issueTnImg {
  background: #fff;
  box-shadow: 0px 3.22188px 12.08207px 2.41641px rgba(0, 0, 0, 0.07);
  height: 100%;
  max-height: 45vh;
  max-width: 100%;
  object-fit: contain;
  width: auto;
}

.hide {
  animation: enlarge 0.5s forwards;
}

.swipeRight {
  animation: swipeRight 0.3s forwards;
}

.swipeLeft {
  animation: swipeLeft 0.3s forwards;
}

.enterRight {
  animation: enterRight 0.3s forwards;
}

.enterLeft {
  animation: enterLeft 0.3s forwards;
}

@keyframes enlarge {
  0% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(1.3, 1.3) translateY(-10%);
  }
}

@keyframes swipeRight {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(135%);
    opacity: 0;
  }
}

@keyframes swipeLeft {
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(-100%);
    opacity: 0;
  }
}

@keyframes enterRight {
  0% {
    transform: translateX(135%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes enterLeft {
  0% {
    transform: translateX(-135%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}

@media screen and (max-height: 700px) {
  .issueTnImg {
    height: 40svh;
  }
}
